import React, { FormEvent } from 'react';
import { Link, navigate } from '@reach/router';
import { auth } from '../../firebase/firebase.utils';
import ls from 'local-storage';
import TimeslipTimer from './TimeslipTimer';

interface IProps { }

const NavLink = (props: any) => (
    <Link
        {...props}
        getProps={({ isCurrent }) => {
            return { className: isCurrent ? 'nav-link active' : 'nav-link' };
        }}
    />
);

// Handle logging a user out
const logout = (e: FormEvent) : void => {
    // Prevent the link from redirecting the user
    e.preventDefault();

    // Clear the local storage cache
    ls.clear();

    // Sign the user out and then redirect to the login page
    auth.signOut().then(() => navigate('/'));
};

const HeaderBar: React.FC<IProps> = (): JSX.Element =>
<nav className="navbar navbar-expand-lg navbar-dark navbar-stick-dark shadow-2" data-navbar="static" style={{ backgroundColor: '#fff' }}>
    <div className="container">
        <div className="navbar-left mr-4">
            <button className="navbar-toggler" type="button">&#9776;</button>
            <Link to="/dashboard" className="navbar-brand">
                <img className="logo-dark" src="https://lunarcow.nyc3.digitaloceanspaces.com/img/logo-dark.png" alt="logo" style={{ height: '39px' }} />
            </Link>
        </div>
        <section className="navbar-mobile">
            <nav className="nav nav-navbar mr-auto">
                <NavLink className="nav-link" to="/dashboard">Dashboard</NavLink>
                <NavLink className="nav-link" to="/companies">Companies</NavLink>
                <NavLink className="nav-link" to="/projects">Projects</NavLink>

                <li className="nav-item" style={{ zIndex: 1001 }}>
                    <a className="nav-link" href="#">Tools <span className="arrow" /></a>
                    <ul className="nav">
                        <li className="nav-item">
                            <NavLink
                                className="nav-link"
                                to="/concepts">
                                Concept Library
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link"
                                to="/sales-proposals">
                                Sales Proposals
                            </NavLink>
                        </li>
                    </ul>
                </li>

                <li className="nav-item" style={{ zIndex: 1001 }}>
                    <a className="nav-link" href="#">Reports <span className="arrow" /></a>
                    <ul className="nav">
                        <li className="nav-item">
                            <NavLink
                                className="nav-link"
                                to="/reports/client-contact">
                                Client Contact
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link"
                                to="/reports/daily-sales">
                                Daily Sales
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link"
                                to="/reports/designer-variance">
                                Designer Variance
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link"
                                to="/reports/sales-audit">
                                Sales Audit
                            </NavLink>
                        </li>
                    </ul>
                </li>
            </nav>

            {/*}
            <form className="col-3 mt-3">
                <div className="form-group input-group">
                    <div className="input-group-prepend">
                        <span className="input-group-text">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M18.319 14.4326C20.7628 11.2941 20.542 6.75347 17.6569 3.86829C14.5327 0.744098 9.46734 0.744098 6.34315 3.86829C3.21895 6.99249 3.21895 12.0578 6.34315 15.182C9.22833 18.0672 13.769 18.2879 16.9075 15.8442C16.921 15.8595 16.9351 15.8745 16.9497 15.8891L21.1924 20.1317C21.5829 20.5223 22.2161 20.5223 22.6066 20.1317C22.9971 19.7412 22.9971 19.1081 22.6066 18.7175L18.364 14.4749C18.3493 14.4603 18.3343 14.4462 18.319 14.4326ZM16.2426 5.28251C18.5858 7.62565 18.5858 11.4246 16.2426 13.7678C13.8995 16.1109 10.1005 16.1109 7.75736 13.7678C5.41421 11.4246 5.41421 7.62565 7.75736 5.28251C10.1005 2.93936 13.8995 2.93936 16.2426 5.28251Z"
                                    fill="currentColor"
                                />
                            </svg>
                        </span>
                    </div>

                    <input type="text" className="form-control form-control-sm" placeholder="Type to Search" />
                </div>
            </form>

            <span className="navbar-divider"></span>
            */}

            <TimeslipTimer />
            {/* <a className="btn btn-sm btn-success" href="#">Sign up</a> */}

            <span className="navbar-divider"></span>

            <div className="dropdown ml-lg-5">
                <span className="dropdown-toggle no-caret" data-toggle="dropdown">
                    <img className="avatar avatar-xs" src="https://lunarcow.nyc3.digitaloceanspaces.com/img/avatar/1.jpg" alt="user" />
                </span>
                <div className="dropdown-menu dropdown-menu-right" style={{ zIndex: 1001 }}>
                    <Link className="dropdown-item" to="/account">Account</Link>

                    <div className="dropdown-divider" />

                    <a className="dropdown-item" href="#" onClick={logout}>Logout</a>
                </div>
            </div>
        </section>
    </div>
</nav>

export default HeaderBar;
